import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Card, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import moment from 'moment';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class PhysicalExam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: "",
            weight: "",
            abdominalPerimeter: "",
            size: "",
            heartRate: "",
            breathingFrequency: "",
            temperature: "",
            bloodPressure: "",
            BMI: "",
            bodySurface: "",
            age: '',
            load: false
        }
    }
    /*
     componentDidMount() {
         this.setState({ load: true }, ()=>{
           this.props.loadPhysicalExam().then((load) => {
             this.setState({ load: load },()=>{
                 console.log("cargar examenes fisicos !!");
             });
           }).catch((error)=>{
             console.log(error)
           });
         })    
     }*/

    componentDidMount() {

        this.calculateAge(this.props.birthday)
    }

    calculateAge = (birthday) => {
        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);

        this.setState({ age: fecha });
    }

    handlerWeight = (weight) => {
        this.setState({ weight: weight }, () => {
            this.caculateBMI();
            this.calculateSurfaceBody();
        });
    }

    handlerAbdominalPerimeter = (abdominalPerimeter) => {
        this.setState({ abdominalPerimeter: abdominalPerimeter })
    }

    handlerSize = (size) => {
        this.setState({ size: size }, () => {
            this.caculateBMI();
            this.calculateSurfaceBody();
        });
    }

    handlerHeartRate = (heartRate) => {
        this.setState({ heartRate: heartRate });
    }

    handlerBreathingFrequency = (breathingFrequency) => {
        this.setState({ breathingFrequency: breathingFrequency });
    }

    handlerTemperature = (temperature) => {
        this.setState({ temperature: temperature });
    }

    handlerBloodPressure = (bloodPressure) => {
        this.setState({ bloodPressure: bloodPressure });
    }

    handlerSurfaceBody = (bodySurface) => {
        this.setState({ bodySurface: bodySurface });
    }

    caculateBMI = () => {
        if ((this.state.weight !== "" && this.state.weight !== 0) && (this.state.size !== "" && this.state.size !== 0)) {
            var BMI = this.state.weight / (Math.pow(this.state.size, 2)).toFixed(2);
            this.setState({ BMI: BMI });
        }
    }

    handlerBMI = (BMI) => {
        this.setState({ BMI: BMI });
    }

    calculateSurfaceBody = () => {
        var SC = Math.sqrt(((this.state.weight) * (this.state.size)) / 3600);
        this.setState({ bodySurface: SC })
    }

    render() {
        return (
            <Col>
                <Card body outline color="secondary">
                    <div className="card__title">
                        <h5 className="bold-text">Antropometria</h5>
                    </div>
                    <div className="form">
                        <div className="form__half">
                            <div className="form__form-group">
                                <FormControl style={{ width: '50%' }}>
                                    <InputLabel id="demo-simple-select-label">Genero</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        name="select-gender"
                                        id="gender-select"
                                        value={this.props.gender}
                                        disabled={this.props.gender !== ""}
                                        onChange={(e) => {
                                            this.props.handlerPhysicalExam('gender', e.target.value)
                                        }}
                                    >
                                        <MenuItem key={0} value={'Masculino'}>Masculino</MenuItem>
                                        <MenuItem key={1} value={'Femenino'}>Femenino</MenuItem>
                                        <MenuItem key={3} value={'Binario'}>Binario</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex' }}>
                                <div className="form__form-group" style={{ width: '25%' }} >
                                    <span className="form__form-group-label"> Edad: </span>
                                    <div className="form__form-group-field">
                                        <input
                                            key={`comment-age`}
                                            name={`comment-age`}
                                            component={renderField}
                                            disabled={true}
                                            type="text"
                                            value={this.state.age}
                                        />
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ width: '25%', marginLeft: 180 }} >
                                    <span className="form__form-group-label">Peso (Kg)</span>
                                    <div className="form__form-group-field" >
                                        <Field
                                            key={`comment-weight`}
                                            name={`comment-weight`}
                                            component={renderField}
                                            type="number"
                                            placeholder=""
                                            value={this.props.PhysicalExam.weight}
                                            onChange={(e) => {
                                                this.props.handlerWeight(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex' }}>
                                <div className="form__form-group" style={{ width: '25%' }}>
                                    <span className="form__form-group-label">Superficie Corporal (mc)</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                            <input
                                                name="sc"
                                                placeholder=""
                                                type="number"
                                                value={this.state.bodySurface}
                                                value={this.props.PhysicalExam.bodySurface}
                                                onChange={(e) => { this.props.handlerSurfaceBody(e.target.value) }}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ width: '25%', marginLeft: 180 }}>
                                <span className="form__form-group-label">Indice de Masa Corporal</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                        <input
                                            name="body-mass-index"
                                            placeholder=""
                                            type="number"
                                            value={this.props.PhysicalExam.BMI}
                                            onChange={(e) => { this.props.handlerPhysicalExam('BMI', e.target.value) }}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            </div>
                        </div>
                        <div className="form__half">
                            <div className="form__form-group">
                                <FormControl style={{ width: '50%' }}>
                                    <InputLabel id="demo-simple-select-label">Dominancia</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        name="select-dominance"
                                        id="dominance-select"
                                        value={this.props.PhysicalExam.dominance}
                                        disabled={this.props.PhysicalExam.dominance !== ""}
                                        onChange={(e) => { this.props.handlerPhysicalExam('dominance', e.value) }}
                                    >
                                        <MenuItem key={0} value={'Diestro'}>Diestro</MenuItem>
                                        <MenuItem key={1} value={'Zurdo'}>Zurdo</MenuItem>

                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex' }}>
                                <div className="form__form-group" style={{ width: '25%' }}>
                                    <span className="form__form-group-label">Talla (m)</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            key={`size`}
                                            name={`size`}
                                            component={renderField}
                                            type="number"
                                            placeholder=""
                                            value={this.props.PhysicalExam.size}
                                            onChange={(e) => {
                                                this.props.handlerSize(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ width: '25%', marginLeft: 180 }}>
                                    <span className="form__form-group-label">Perimetro Abdominal (cm)</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            key={`abdominal-perimeter`}
                                            name={`abdominal-perimeter`}
                                            component={renderField}
                                            type="number"
                                            placeholder=""
                                            value={this.props.PhysicalExam.abdominalPerimeter}
                                            onChange={(e) => {
                                                this.props.handlerPhysicalExam('abdominalPerimeter', e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                            
                        </div>
                    </div>
                </Card>
                <Card body outline color="secondary">
                    <div className="form" style={{ flex: 1, flexDirection: 'row' }}>
                        <div className="form__form-group" style={{ width: '12%' }}>
                            <span className="form__form-group-label">Frecuencia Cardiaca (lpm)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`heart-rate`}
                                    name={`heart-rate`}
                                    component={renderField}
                                    type="number"
                                    placeholder="frecuencia cardiaca"
                                    value={this.props.PhysicalExam.heartRate}
                                    onChange={(e) => { this.props.handlerPhysicalExam('heartRate', e.target.value) }}
                                />
                            </div>
                        </div>
                        <div className="form__form-group" style={{ width: '14%', marginLeft: 180 }}>
                            <span className="form__form-group-label">Frecuencia Respiratoria (resp/min)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`breathing-frequency`}
                                    name={`breathing-frequency`}
                                    component={renderField}
                                    type="number"
                                    placeholder="frecuencia respiratoria"
                                    value={this.props.PhysicalExam.breathingFrequency}
                                    onChange={(e) => { this.props.handlerPhysicalExam('breathingFrequency', e.target.value) }}
                                />
                            </div>
                        </div>
                        <div className="form__form-group" style={{ width: '12%', marginLeft: 190 }}>
                            <span className="form__form-group-label">Temperatura (°C)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`temperature`}
                                    name={`temperature`}
                                    component={renderField}
                                    type="number"
                                    placeholder="temperatura"
                                    value={this.props.PhysicalExam.temperature}
                                    onChange={(e) => { this.props.handlerPhysicalExam('temperature', e.target.value) }}
                                />
                            </div>
                        </div>
                        <div className="form__form-group" style={{ width: '12%', marginLeft: 190 }}>
                            <span className="form__form-group-label">Presión Arterial (mm/Hg)</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`blood-pressure`}
                                    name={`blood-pressure`}
                                    component={renderField}
                                    type="number"
                                    placeholder=""
                                    value={this.props.PhysicalExam.bloodPressure}
                                    onChange={(e) => { this.props.handlerPhysicalExam('bloodPressure', e.target.value) }}
                                />
                            </div>                           
                        </div>
                        
                    </div>
                </Card>
                <Card body outline color="secondary">
                    <div className="form" style={{ flex: 1 }}>
                        <div className="form__half">
                            <div className="form__form-group">
                                <span className="form__form-group-label">Aspectos Generales</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-general-features"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.generalFeatures}
                                        onChange={(e) => { this.props.handlerPhysicalExam('generalFeatures', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cabeza y cara</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-head-face"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.headAndFace}
                                        onChange={(e) => { this.props.handlerPhysicalExam('headAndFace', e.target.value) }}
                                    />
                                </div>
                            </div>

                            <div className="form__form-group">
                                <span className="form__form-group-label">Ori</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-ori"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.ori}
                                        onChange={(e) => { this.props.handlerPhysicalExam('ori', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Ojos</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-eyes"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.eyes}
                                        onChange={(e) => { this.props.handlerPhysicalExam('eyes', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cuello</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-neck"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.neck}
                                        onChange={(e) => { this.props.handlerPhysicalExam('neck', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Toráx</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-chest"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.chest}
                                        onChange={(e) => { this.props.handlerPhysicalExam('chest', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cardiovascular</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-cardiovascular"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.cardioVascular}
                                        onChange={(e) => { this.props.handlerPhysicalExam('cardioVascular', e.target.value) }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form__half">
                            <div className="form__form-group">
                                <span className="form__form-group-label">Pulmonar</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-pulmonary"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.pulmonary}
                                        onChange={(e) => { this.props.handlerPhysicalExam('pulmonary', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Abdomen</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-abdomen"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.abdomen}
                                        onChange={(e) => { this.props.handlerPhysicalExam('abdomen', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Extremidades</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-limbs"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.limbs}
                                        onChange={(e) => { this.props.handlerPhysicalExam('limbs', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Neurologico</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-neurological"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.neurological}
                                        onChange={(e) => { this.props.handlerPhysicalExam('neurological', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Genitourinario</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-genitourinary"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.genitourinary}
                                        onChange={(e) => { this.props.handlerPhysicalExam('genitourinary', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Piel Faneras</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-skin-appendages"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.skin_appendages}
                                        onChange={(e) => { this.props.handlerPhysicalExam('skin_appendages', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Otorrino</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-otorhino"
                                        component="textarea"
                                        type="text"
                                        value={this.props.PhysicalExam.otorhino}
                                        onChange={(e) => { this.props.handlerPhysicalExam('otorhino', e.target.value) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Col>)
    }

}


export default reduxForm({
    form: `physical-exam-form`, // a unique identifier for this form
})(withTranslation('common')(PhysicalExam));

